declare let window: Window & {
  VUE_APP_API: string;
  UM_URL: string;
};

export default {
  briumApiBaseUrl: window["VUE_APP_API"] || process.env.VUE_APP_API,
  universityUrl: window["UM_URL"] || "https://um.si",
};
